import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, data, exec, isLoading } = useRequest({
    url: ``,
    name: 'MAINTAIN_PLAN_VIEW',
    method: 'GET',
  });

  const fetchData = function () {
    if (params) {
      let url = `/api/maintain/machview`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [isRequestSuccessed, data || [], fetchData, isLoading];
});
